import styled from 'styled-components';
import { COLOR } from '../../../../packages/constants';
import { AccountCell } from '../account-cell/account-cell';
import { AccountRow } from '../account-row/account-row';
import { removeScrollbar } from '../data-grid-scroller/data-grid-scroller';

const shadowWidth = 8;

export const StyledTable = styled.table`
    border-top: 1px solid ${COLOR.MAIN.FORM_FIELD};
    ${AccountRow}:first-child ${AccountCell} {
        border-top: none;
    }
`;

export const DataGridTotal = styled.table`
    border-top: 1px solid ${COLOR.MAIN.FORM_FIELD};
    position: relative;
    width: 130px;

    tr:first-child ${AccountCell} {
        border-top: none;
    }

    ${AccountCell} {
        border-left: 1px solid ${COLOR.DATAGRID.DATAGRID_DIVIDER_LINE};

        &:last-child {
            border-right: 0;
        }
    }

    &::after {
        background-image: linear-gradient(90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.07));
        content: '';
        position: absolute;
        top: 0;
        left: -${shadowWidth}px;
        height: 100%;
        width: ${shadowWidth}px;
    }
`;

export const StyledFloatTable = styled.table`
    border-top: 1px solid ${COLOR.MAIN.FORM_FIELD};
    border-bottom: 1px solid ${COLOR.MAIN.FORM_FIELD};
`;

export const AccountHeader = styled.thead`
    width: 100%;
`;

export const FloatTableHead = styled.div`
    position: sticky;
    z-index: 12;
    top: 0;
`;

export const FloatHead = styled.div`
    box-sizing: border-box;
    border-left: 1px solid ${COLOR.MAIN.FORM_FIELD};
    position: sticky;
    z-index: 12;
    top: 0;
    display: flex;
    width: 100%;
    overflow: auto;

    ${removeScrollbar}

    ${AccountCell} {
        &:last-child {
            border-right: 0;
        }
    }
`;
